import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49699be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pagination-group__btn"
}
const _hoisted_2 = { class: "pagination-group__inputBox" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingPaginationGroup',
  props: {
    showBtn: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ withoutBtn: !_ctx.showBtn }, "pagination-group"])
  }, [
    _createVNode(_component_base_skeleton_loader, {
      style: { height: '36px', width: '300px' },
      type: "mediumText"
    }),
    (_ctx.showBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_base_skeleton_loader, {
            style: { height: '36px', width: '165px' },
            type: "text"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_skeleton_loader, {
        style: { height: '36px', width: '180px' },
        type: "text"
      })
    ])
  ], 2))
}
}

})